import { useEffect, useState } from "react";
import { BillGreyIcon, CalendarGreyIcon, ClocckGreyIcon, FoodItemGreyIcon, LocationGreenIcon, LocationGreyIcon, MailGreyIcon, StoreBlackIcon, TableBlackIcon, TableFrontGreyIcon, TableGreyIcon, TelephoneIcon, UserGreyIcon } from "../../../../assets/icons";
import { handleErrorNotification } from "../../../../utils/errorNotificatioMessage";
import Loader from "../../../shared/Loader";
import { useAuth } from "../../../../auth/AuthContext";
import { useNotification } from "../../../toster-notification/NotificationContext";
import { useNavigate } from "react-router-dom";
import { ClientOrderListItemDTO } from "../../../../models/order/order.response";
import { orderService } from "../../../../services/orderService";
import { ToLocalDateString, ToLocalDateTimeString } from "../../../../utils/dateFormater";
import { OrderType } from "../../../../models/base/OrderType";
import { OrderStatusType, orderStatusTypeToClassName, orderStatusTypeToString } from "../../../../models/base/OrderStatusType";




const ClientProfileOrderTab: React.FC = () => {

    const [orders, setOrders] = useState<ClientOrderListItemDTO[]>([]);
    const [locals, setLocals] = useState<string[]>([]);

    const [filterText, setFilterText] = useState<string>("");
    const [filterLocal, setFilterLocal] = useState<string>("");
    const [filterDateFrom, setFilterDateFrom] = useState<string>(new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
    const [filterDateTo, setFilterDateTo] = useState<string>(new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
    const [filterOrderStatus, setFilterOrderStatus] = useState<OrderStatusType | "">("");
    const [filterOrderType, setFilterOrderType] = useState<OrderType | "">("");


    const [loading, setLoading] = useState<boolean>(false);
    const { user } = useAuth();
    const { notify } = useNotification();
    const navigate = useNavigate();


    useEffect(() => {
        fetchOrders();
    }, []);


    const fetchOrders = async () => {
        if (!user || !user.id) {
            notify("error", "Korisnik nije prijavljen.");
            navigate("/login");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.getUsersOrders(user.id, new Date(filterDateFrom), new Date(filterDateTo), filterOrderType as OrderType, filterOrderStatus as OrderStatusType);

            if (response.success && response.data) {
                setOrders(response.data);
                setLocals(Array.from(new Set(response.data.map(order => order.localName))));
            } else {
                notify("error", response.message || "Neuspešno učitavanje porudžbina.");
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom učitavanja porudžbina.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const resetFilters = () => {
        setFilterText("");
        setFilterLocal("");
        setFilterDateFrom(new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
        setFilterDateTo(new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]);
        setFilterOrderStatus("");
        setFilterOrderType("");
    };

    const orderTypeHtml = (type: OrderType, order: ClientOrderListItemDTO) => {
        switch (type) {
            case OrderType.DineIn:
                return (

                    <>
                        <img src={TableFrontGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                        <div className="div-block-44">
                            <div className="description-text">Sto</div>
                            <div className="text-block-32">{order.tableNumber}</div>
                        </div>
                    </>
                );
            case OrderType.Pickup:
                return (
                    <>
                        <img src={ClocckGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                        <div className="div-block-44">
                            <div className="description-text">Vreme dolaska po porudžbinu</div>
                            <div className="text-block-32">{ToLocalDateTimeString(order.pickUpAt.toString())}</div>
                        </div>
                    </>
                );
            case OrderType.Delivery:
                return (
                    <>
                        <img src={LocationGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                        <div className="div-block-44">
                            <div className="description-text">Adresa</div>
                            <div className="text-block-32">{order.street}, {order.streetNumber}{order.apartment ? `/${order.apartment}` : ""}</div>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <div className="admin-settings-box-div filter">
                <div className="filter-header-div">
                    <div className="fs-1-25rem">Filteri</div>
                </div>
                <div className="w-form">
                    <form className="form-8">

                        <div className="filter-div">
                            <div className="description-text">Pretraga</div>
                            <input className="form-input grey w-input" placeholder="Pretraga po id, imenu korisnika, adresi..." type="text"
                                value={filterText}
                                onChange={(e) => setFilterText(e.target.value)}
                            />
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Lokal</div>
                            <select className="form-select grey auto-width w-select"
                                value={filterLocal}
                                onChange={(e) => setFilterLocal(e.target.value)}
                            >
                                <option value="">Bilo koji</option>
                                {locals.map((local) => (
                                    <option key={local} value={local}>{local}</option>
                                ))}
                            </select>
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Datum od</div>
                            <input className="form-input grey w-input" placeholder="Pretraga po id, imenu korisnika, adresi..." type="date"
                                value={filterDateFrom}
                                onChange={(e) => setFilterDateFrom(e.target.value)}
                            />
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Datum do</div>
                            <input className="form-input grey w-input" placeholder="Pretraga po id, imenu korisnika, adresi..." type="date"
                                value={filterDateTo}
                                onChange={(e) => setFilterDateTo(e.target.value)}
                            />
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Status</div>
                            <select className="form-select grey auto-width w-select"
                                value={filterOrderStatus}
                                onChange={(e) => setFilterOrderStatus(Number(e.target.value))}
                            >
                                <option value="">Bilo koji</option>
                                <option value={OrderStatusType.Ordered}>Naruceno</option>
                                <option value={OrderStatusType.Recived}>Primljeno</option>
                                <option value={OrderStatusType.Served}>Servirano</option>
                                <option value={OrderStatusType.Bill}>Racun</option>
                                <option value={OrderStatusType.Paid}>Placeno</option>
                                <option value={OrderStatusType.Finished}>Zavrseno</option>
                                <option value={OrderStatusType.Cancelled}>Otkazano</option>
                            </select>
                        </div>

                        <div className="filter-div">
                            <div className="description-text">Tip</div>
                            <select className="form-select grey auto-width w-select"
                                value={filterOrderType}
                                onChange={(e) => setFilterOrderType(e.target.value as OrderType | "")}
                            >
                                <option value="">Bilo koji</option>
                                <option value={OrderType.Delivery}>Dostava</option>
                                <option value={OrderType.Pickup}>Preuzimanje</option>
                                <option value={OrderType.DineIn}>U restoranu</option>
                            </select>
                        </div>

                    </form>
                </div>
                <div className="filter-bottom-div">
                    <div className="fs-1rem description-text">
                        Prikazano: <span className="text-span-7">{orders.length} </span>
                        {/* od 9 rezervacija */}
                    </div>
                    <div className="filter-bouttons-div">
                        <div className="small-box-div transparent-border pointer" onClick={() => resetFilters()}>
                            <div>Resetuj</div>
                        </div>
                        <div className="small-box-div light-blue-bg pointer height-35px width-200px" onClick={() => fetchOrders()}>
                            <div>Primeni filtere</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="user-page-orders-list-div">

                {orders
                    .filter((order) => {
                        const searchText = filterText.toLowerCase();
                        if (!order.localName.toLowerCase().includes(searchText) &&
                            !order.fullName.toLowerCase().includes(searchText) &&
                            !order.email.toLowerCase().includes(searchText) &&
                            !order.phoneNumber.toLowerCase().includes(searchText) &&
                            !order.id.toLowerCase().includes(searchText) &&
                            !order.tableNumber?.toString().includes(searchText) &&
                            !order.street.toLowerCase().includes(searchText)) {
                            return false;
                        }

                        if (filterLocal && order.localName !== filterLocal) {
                            return false;
                        }

                        return true;
                    })
                    .map((order) => (
                        <div className="admin-settings-box-div orders">
                            <div className="admin-settings-box-header-div">
                                <div className="admin-settings-box-header-info-div">
                                    <div className="admin-settings-box-header-info-title-div">
                                        <img src={StoreBlackIcon} loading="lazy" alt="" className="icon-size-20" />
                                        <div className="admin-settings-box-header-info-title">Restoran Zlatna Lađa</div>
                                    </div>
                                    <div className="description-text">Porudžbina #{order.id}</div>
                                </div>
                                <div className="admin-settings-box-header-actions-div">
                                    <div className={`small-box-div ${orderStatusTypeToClassName(order.currentStatus)}`}>
                                        <div>{orderStatusTypeToString(order.currentStatus)}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="admin-settings-box-body-div">
                                {order.isForAnotherPerson && (
                                    <div className="user-profile-user-info">
                                        <div className="text-block-33">Podaci o porudžbini:</div>
                                        <div className="div-block-54">
                                            <div className="div-block-53">
                                                <img src={UserGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                                <div className="text-block-34">{order.fullName}</div>
                                            </div>
                                            <div className="div-block-53">
                                                <img src={MailGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                                <div>{order.email}</div>
                                            </div>
                                            <div className="div-block-53">
                                                <img src={TelephoneIcon} loading="lazy" alt="" className="icon-size-20" />
                                                <div>{order.phoneNumber}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="div-block-46">
                                    <div className="div-block-43">
                                        <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                                        <div className="div-block-44">
                                            <div className="description-text">Datum i vreme</div>
                                            <div className="text-block-32">{ToLocalDateTimeString(order.createdAt.toString())}</div>
                                        </div>
                                    </div>
                                    <div className="div-block-43">
                                        {orderTypeHtml(order.type, order)}
                                    </div>
                                    <div className="div-block-43">
                                        <img src={FoodItemGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                                        <div className="div-block-44">
                                            <div className="description-text">Stavki</div>
                                            <div className="text-block-32">{order.orderItems.length}</div>
                                        </div>
                                    </div>
                                    <div className="div-block-43">
                                        <img src={BillGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                                        <div className="div-block-44">
                                            <div className="description-text">Ukupno</div>
                                            <div className="text-block-32">{order.orderItems.reduce((total, item) => total + item.price * item.quantity, 0)} RSD</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-body-hr"></div>
                                <div className="user-page-orders-items-list-box">
                                    <div className="user-page-orders-items-list-title">Stavke:</div>
                                    <div className="user-page-orders-items-list-div">
                                        {order.orderItems.map((item, index) => (
                                            <div className="user-page-orders-items-div" key={index}>
                                                <div className="div-block-47">
                                                    <div className="bold"> <span className="text-span-5 description-text">{item.quantity}x</span> {item.name}<span className="text-span-10"> /{item.label}</span></div>
                                                    <div className="description-text">{item.description}</div>
                                                </div>
                                                <div>
                                                    <div className="bold">{item.price * item.quantity} RSD</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {order.description && (
                                    <div id="w-node-f9bc1d91-ebca-f1d9-ffcc-0c3ea64878f0-d5e61be0" className="div-block-43 side-padding-0">
                                        <div className="div-block-44">
                                            <div className="description-text">Napomena</div>
                                            <div className="input-div light-blue-bg">
                                                {order.description}
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    ))}

            </div>

        </>
    );
};

export default ClientProfileOrderTab;